export const dutTexts = {
	knowMore: 'Meer weten',
	ngoPurpose:
		"To raise funds for the NGO's projects, keep you up	to date on the NGO and the progress of the project you donated to and issue tax	deduction certificates.",
	termsPurpose:
		'Manage the business relationship in all its fields, as well as its donation and certificate application, and the sending of commercial communications electronically.',
	termsRights:
		'You have	the right to access, correct and delete your data, as well as other rights, as explained	in the additional information.',
	termsAdditionalInfo:
		'You can consult additional and detailed Data Protection information on our <a href="https://www.worldcoo.com/gdpr">website</a> or by <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a>',
	unexpectedError: 'Er is een onverwachte fout opgetreden',
	amountError: 'Ní raibh an méid airgid bailí',
	authError: 'Er is een verwijzingsfout opgetreden',
	cardError: 'Tharla earráid le do chárta',
	referralError: 'Er is een verwijzingsfout opgetreden',
	transactionError: 'Er is een fout opgetreden bij de transactie',
	resetFilters: 'Reset filters',
	category: 'Oorzaak',
	basicNeeds: 'Basisbehoeften',
	humanRights: 'Mensenrechten',
	education: 'Opleiding',
	emergency: 'Noodgeval',
	feeding: 'Vervoer',
	environment: 'Milieu',
	habitat: 'Leefgebied',
	health: 'Gezondheid',
	clear: 'Wissen',
	active: 'Actief',
	finished: 'Afgerond',
	status: 'Status',
	year: 'Jaar',
	filters: 'Filters',
	campaignAudited: 'Campagne gecontroleerd door Worldcoo',
	treesFAQ1: 'Kunt u meer informatie verstrekken over Conservation International ("CI") en hun doel?',
	treesFAQ2: 'Wat is de "Dedicate a Tree" optie?',
	treesFAQ3:
		'Worden er kosten ingehouden op mijn donatie? Zal Conservation International mijn volledige donatie ontvangen?',
	treesFAQ4:
		'Wat is Worldcoo? Waarom gaat mijn donatie daarheen en niet rechtstreeks naar Conservation International? ',
	treesFAQ5: 'Hoe zal deze donatie op mijn bankafschrift verschijnen? ',
	treesFAQ6: 'Hoe werkt de donatievergelijking? ',
	treesFAQResponse1: `CI is een milieuorganisatie zonder winstoogmerk, die in de Verenigde Staten is erkend als een 501(c)(3) liefdadigheidsorganisatie. Opgemerkt zij dat CI geen geregistreerde liefdadigheidsinstelling is in Engeland en Wales of enig ander deel van het Verenigd Koninkrijk. De belangrijkste prioriteiten van CI zijn (i) bescherming van de natuur om de klimaatcatastrofe een halt toe te roepen; (ii) bescherming van de oceaan om de mensheid te beschermen; en (iii) het sturen op duurzaam land en water. Sinds hun oprichting hebben ze geholpen om meer dan 6 miljoen vierkante kilometer land en zee te beschermen in meer dan 70 landen. Momenteel hebben ze kantoren in 29 landen en 2.000 partners wereldwijd, dus hun bereik is echt wereldwijd. Zie hun website voor meer informatie: https://www.conservation.org/about `,
	treesFAQResponse2: `U kunt uw donatie opdragen aan een vriend of familielid ("Ontvanger"). Als u voor deze optie kiest, stuurt Mastercard Donate namens u een e-mail naar de ontvanger op het e-mailadres dat u opgeeft voor de ontvanger.  Als u geen gebruik wenst te maken van deze "Dedication"-optie, kunt u deze stap overslaan en doorgaan met uw donatie. `,
	treesFAQResponse3: `Er zullen u geen extra kosten in rekening worden gebracht, maar van uw donatiebedrag zullen standaard verwerkingskosten voor kaarten worden afgetrokken en Worldcoo S.L. ("Worldcoo"), een tussenpersoon voor fondsenwerving, zal Conservation International 6% administratiekosten in rekening brengen over uw donatie en alle toepasselijke standaard verwerkingskosten voor transacties die door hen zijn gemaakt, terugvorderen. Bij het beïnvloeden van de betaling van uw donatie aan Conservation International, zal Worldcoo deze omzetten van EUR naar USD met gebruikmaking van de geldende wisselkoers.`,
	treesFAQResponse4: `Worldcoo is een Spaanse onderneming die gespecialiseerd is in het mogelijk maken van e-commerce sites om sociale en samenwerkingsprojecten te financieren. Mastercard werkt samen met Worldcoo om donaties aan Conservation International te faciliteren. Worldcoo zal een overeenkomstige betaling doen voor het bedrag dat u aan Conservation International heeft gedoneerd in US dollars. Donaties worden niet gerestitueerd. Worldcoo zal verschijnen als de geregistreerde handelaar voor uw kaart die het bedrag van uw donatie in rekening brengt. Conservation International zal het geld binnen drie maanden na uw oorspronkelijke donatie ontvangen.Donaties worden onmiddellijk verwerkt en kunnen als zodanig niet worden gewijzigd of geannuleerd zodra ze zijn gedaan. Donaties via de site zijn daarom onherroepelijk en er worden geen terugbetalingen verwerkt, behalve in het onwaarschijnlijke en onfortuinlijke geval dat een van de Liefdadigheidsinstellingen niet in staat is om bedragen te accepteren die via het Mastercard Donate-platform worden geïnd  (bijvoorbeeld omdat ze ophouden te bestaan of hun status van Liefdadigheidsinstelling verliezen etc.), zal uw donatie onmiddellijk aan u worden terugbetaald door Worldcoo, via dezelfde betaalmethode als waarmee de donatie is gedaan.`,
	treesFAQResponse5: `Worldcoo zal optreden als de geregistreerde handelaar voor het bedrag van uw donatie op de kaart die in rekening wordt gebracht op Conservation International. `,
	treesFAQResponse6: `Mastercard verdubbelt de donaties aan Conservation International in Nederland met een Mastercard op de doneerpagina waarnaar hierboven wordt verwezen, tot 15 mei, boom voor boom, euro voor euro, tot een totaal van €20.000. Zie de doneerpagina voor aanvullende voorwaarden.`,
	costPerTreeAproximate: 'De kosten per boom zijn een schatting.',
	treesDonateInputMessage: 'Gebruik je Mastercard om te doneren en wij matchen boom voor boom, euro voor euro.**',
	aboutConservationInternational: 'Over Conservation International',
	dedicateToTemplate:
		'Hello! You receive this email because {{donorName}} has given you a donation of {{amount}} {{currency}} for the NGO {{ngoName}} in the campaign {{campaignName}}. This donation has been dedicated to you with the intention of making the world a little better place',
	dedicateToTemplateTitle: 'Stuur een berichtje om te laten weten dat je om ze geeft',
	dedicateToWarning:
		'Dit bericht wordt naar de ontvanger gestuurd op het hierboven opgegeven e-mailadres. Ik bevestig dat ik toestemming heb gevraagd aan de ontvanger om dit bericht te verzenden',
	dedicateToRecipientEmail: 'E-mailadres van de ontvanger',
	dedicateToRecipientName: 'Naam van de ontvanger',
	dedicateDonationTitle: 'Ik wil deze donatie aan iemand opdragen.',
	dedicateDonationMessage: 'Ik zou mijn donatie graag aan iemand willen opdragen',
	aCampaignBy: 'Een campagne van',
	acceptNgoTermsLink:
		'Ik heb de gelezen, begrepen en geaccepteerd <a class="terms_button" data-open-modal="ngoTerms" data-modal-classes="terms-modal full-scroll" href="#">Beschermingsvoorwaarden van @ngo</a>',
	acceptRecurrentTermsLink:
		'Ik heb de gelezen, begrepen en geaccepteerd <a class="terms_button" data-open-modal="recurrentTerms" data-modal-classes="terms-modal full-scroll" href="#">Voorwaarden voor gegevensbescherming van NGO\'s</a>',
	activities: 'Activiteiten',
	additionalInfo: 'Extra informatie',
	anyComments: 'Wil je een opmerking maken?',
	businessName: 'Bedrijfsnaam',
	campaignObjectives: 'Campagnedoelstellingen',
	campaignFunded: 'Campagne Opgehaald!',
	campaigns: 'Klokken',
	cancel: 'annuleren',
	cardBrandNotAccepted: 'Dit soort kaarten wordt niet geaccepteerd.',
	cardRegisteredSuccessfully: 'De kaart is succesvol geregistreerd',
	cardsSupported: 'Ondersteunde kaarten:',
	certificateOnlyValidInExpeditionCountry:
		'Het donatiecertificaat is alleen geldig in het land van herkomst waar de begunstigde entiteit van de donaties is geregistreerd.',
	certificateNeededData: 'Benodigde informatie om het donatiecertificaat te verkrijgen:',
	change: 'Verandering',
	checkoutSuccess: 'Uw donatie is gelukt, bedankt voor uw deelname.',
	city: 'Stad',
	collectedFundsDistribution: 'De ingezamelde middelen worden gelijk verdeeld over de volgende projecten:',
	comments: 'Opmerkingen',
	company: 'Bedrijf',
	confirm: 'Bevestigen',
	contactData: 'Voer je gegevens in',
	cookiesMessage:
		'Deze site maakt gebruik van cookies. Als u doorgaat met surfen, gaan we ervan uit dat u het gebruik ervan accepteert',
	country: 'Land',
	creditCard: 'Kredietkaart',
	dataReceivedSuccessfully: 'We hebben uw gegevens met succes ontvangen.',
	description: 'Omschrijving',
	directBeneficiaries: 'Directe begunstigden',
	directBeneficiariesDescription:
		'De mensen die van nature hebben geprofiteerd van de acties die in de campagne zijn ontwikkeld',
	documentNumber: 'Document Nummer',
	documentType: 'Type document',
	donationAmount: 'Donatie bedrag',
	donationAmountError: 'Het donatiebedrag is niet correct',
	donationAmountMinimumIs: 'Het minimumbedrag is {{amount}}',
	donationCertificate: 'Donatiecertificaat',
	donations: 'Donaties',
	donors: 'Donaties',
	donated: 'Geschonken',
	donatedOf: 'Gedoneerd van',
	donateMonthly: 'Doneer maandelijks',
	donationOnBehalf: 'Maak een donatie namens',
	door: 'Deur',
	email: 'E-mailadres',
	fillFollowingFields: 'Vul de volgende velden in',
	finish: 'Afronden',
	floor: 'Verdieping',
	funded: 'Opgehaald',
	genericCardError: 'Er is een fout opgetreden met je kaart.',
	goBack: 'terugkeer',
	identityDocument: 'Identificatie document',
	indicateDataToIdentify: 'Geef ons deze informatie zodat we u kunnen identificeren:',
	indirectBeneficiaries: 'Indirecte begunstigden',
	indirectBeneficiariesDescription:
		'Die identificeerbare mensen, die een potentieel effect krijgen van de acties die in de campagne zijn ontwikkeld.',
	inDoubtContactHere: 'Voor al uw vragen kunt u hier contact met ons opnemen:',
	informYouViaMail: 'We zullen u per e-mail in detail informeren.',
	makeDonation: 'Doneer',
	makeOneTimeDonation: 'Doe op tijd een donatie',
	makeYourDonation: 'Doe een donatie',
	manageMyDonations: 'Beheer mijn donaties',
	manyThanks: 'Hartelijk dank!',
	modifyAmount: 'Wijzig het donatiebedrag',
	modifyRecurrentDonationSuccess:
		'<p class="margin-top-40">We hebben uw verzoek correct ontvangen..</p><p>Over een paar dagen sturen we u een e-mail om te bevestigen dat we de door u gewenste wijzigingen hebben aangebracht.</p><p>Voor vragen kunt u hier contact met ons opnemen:</p><p class="margin-top-20"><strong><a href="mailto:contact@worldcoo.com">contact@worldcoo.com</a></strong></p>',
	modifyRecurrentDonationTitle: 'Als u al donateur bent, kunt u hier uw donatie wijzigen of annuleren:',
	moreInfo: 'Meer informatie',
	name: 'Naam',
	next: 'Volgend',
	otherAmount: 'Ander bedrag',
	overlayError:
		'<p>Er is een fout opgetreden</p><p>Probeer het later opnieuw of neem hier contact met ons op:</p><p><strong>contact@worldcoo.com</strong></p>',
	particular: 'Persoon',
	paymentData: 'Betalingsdetails',
	paymentType: 'Manier om te betalen',
	personalData: 'Persoonlijke informatie',
	pleaseFillFields: 'Vul de volgende gegevens in:',
	postalCode: 'Postcode',
	province: 'Provincie',
	raised: 'Opgehaald',
	raisedTillNow: 'Verhoogd tot nu toe:',
	recurrentFormError:
		'Er is een fout opgetreden bij het verwerken van uw verzoek. Probeer het later opnieuw of neem hier contact met ons op:',
	region: 'Regio',
	repeatEmail: 'Herhaal e-mailadres',
	repsolEmployeesPortal: 'Solidariteitsportaal voor werknemers',
	seeCampaigns: 'Zie campagnes',
	send: 'Sturen',
	share: 'Delen',
	sorry: 'We vinden het jammer!',
	stairNumber: 'Trap',
	stopMakingDonation: 'Stop maandelijks met doneren',
	step1: 'Stap 1',
	step2: 'Stap 2',
	step3: 'Stap 3',
	step4: 'Stap 4',
	streetName: 'Straat',
	streetNumber: 'Num.',
	streetType: 'Soort weg',
	summary: 'Overzicht',
	surname: 'Achternaam',
	telefonicaUseCorporateMail:
		'* Bent u een actieve Telefónica-medewerker, gebruik dan bij voorkeur uw zakelijke e-mailadres.',
	thanks: 'Dank u!',
	typeTheAmount: 'Typ het bedrag',
	unavailableLanguageMessage:
		'We hebben de inhoud van deze campagne niet in het Nederlands. We werken voortdurend aan het leveren van meer inhoud in uw taal. Bedankt voor je geduld.',
	updatesAndLinks: 'Updates en links',
	validationEqualFields: 'De velden {{label}} en {{fieldName}} ze zijn niet hetzelfde',
	validationIsRequired: 'Het veld {{label}} is verplicht',
	validationValidEmail: 'Het veld {{label}} is geen geldig e-mailadres',
	viewCampaignInfo: 'Bekijk campagne-informatie',
	viewInfo: 'Zie informatie',
	wantCertificate: 'Ik wil graag een donatiecertificaat ontvangen',
	wantWorldcooNewsletter: 'Ik wens informatie te ontvangen van Worldcoo',
	whatIsNewAmount: 'Vertel ons wat het nieuwe bedrag is dat u wilt doneren (in {{currency}}):',
	whatYouWantToDo: 'Jij wilt doen?',
	whoWillBenefit: 'Aan wie komt de donatie ten goede?',
	youCanAlsoDonateOneTime: 'Je kunt ook een specifieke donatie doen door naar een van hen te gaan.',
	yourDonationWillBeCharged: 'Uw donatie wordt op de 15e van elke maand in rekening gebracht.',
	yourRequestIsProcessing: 'Uw verzoek wordt verwerkt. Wacht een paar seconden, alstublieft.',
	youSureCancelRecurrentDonation: 'Bevestig je dat je wilt stoppen met een maandelijkse donatie?',
	ngoLegitimation: 'The legal basis for handling your data is your consent.',
	ngoRecipients: 'No data shall be transferred to third parties.',
	ngoAdditionalInfoEmail:
		'You can consult the additional and detailed information on Data Protection on the website of each NGO.',
	ngoAdditionalInfoUrl:
		'Op onze website kunt u aanvullende en gedetailleerde informatie over gegevensbescherming raadplegen: ',
	amountMustBeGreaterThanZero: 'Het bedrag moet groter zijn dan 0',
	amountMustBeLowerThan3000: 'Het bedrag moet lager zijn dan 3000',
	id: 'ID Nuumer',
	taxId: 'Tax ID Number',
	passport: 'Passport',
	others: 'Others',
	metafieldsNoTicket: 'Zeile 0. Spende ohne Eintrag',
	metafieldsTickets:
		'Wie viele Einladungen benötigen Sie für das Konzert? Denken Sie daran, dass Sie für jede gespendete 10 € eine Einladung erhalten.',
};
